export default __webpack_public_path__ + "under-review-icon.svg";